import { render } from "./FormCheckInput.vue?vue&type=template&id=36f925eb&ts=true"
import script from "./FormCheckInput.vue?vue&type=script&lang=ts"
export * from "./FormCheckInput.vue?vue&type=script&lang=ts"

import "./FormCheckInput.vue?vue&type=style&index=0&id=36f925eb&lang=css"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__